import React, { useEffect, useState } from 'react'
import '../css/HomeNav.css'
import image from '../images/SG_letter.jpg'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import NextWeekOutlinedIcon from '@material-ui/icons/NextWeekOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined';
import { Link } from 'react-router-dom';
import ListIcon from '@material-ui/icons/List';
import $ from 'jquery'



function HomeNav({ pathName }) {
    const [variable, setVariable] = useState(false)
    useEffect(() => {
        $("#nav_list").click(function () {
            $(".nav_list").toggleClass('active');
        });

    }, [])
    useEffect(() => {
        if ($(window).width() <= 640) {
            if (variable !== true) {
                $(".nav_items").toggleClass("navClickedState");
                $(".nav_items").css({ display: 'none' });
            }
            else {
                $(".nav_items").css({ display: 'flex' });
                $("#nav_list").click(function () {
                    $(".nav_items").toggleClass("navClickedState");
                });
            }
        }
    }, [variable])
    return (
        <div className='homenav'>
            {/* <img src={image} alt="Shakthi's portfolio"></img> */}
            <div id='nav_list' onClick={() => setVariable(true)}>
                <ListIcon className='nav_list' />
            </div>
            <div className='nav_items'>
                <div className="single_nav_item">
                    <Link to='/' style={{ textDecoration: 'none' }}>
                        <HomeOutlinedIcon id='nav_icons' className={pathName == '/' ? "active" : "passive"} />
                        <p id='nav_captions'>Home</p>
                    </Link>
                </div>
                <div className="single_nav_item">
                    <Link to='/aboutme' style={{ textDecoration: 'none' }}>
                        <PermIdentityOutlinedIcon id='nav_icons' className={pathName == '/aboutme' ? "active" : "passive"} />
                        <p id='nav_captions'>About Me</p>
                    </Link>
                </div>
                <div className="single_nav_item">
                    <Link to='/skills' style={{ textDecoration: 'none' }}>
                        <SettingsOutlinedIcon id='nav_icons' className={pathName == '/skills' ? "active" : "passive"} />
                        <p id='nav_captions' >Skills</p>
                    </Link>
                </div>
                <div className="single_nav_item">
                    <Link to='/myworks' style={{ textDecoration: 'none' }}>
                        <NextWeekOutlinedIcon id='nav_icons' className={pathName == '/myworks' ? "active" : "passive"} />
                        <p id='nav_captions'>My Works</p>
                    </Link>
                </div>
                <div className="single_nav_item">
                    <Link to='/contactme' style={{ textDecoration: 'none' }}>
                        <EmailOutlinedIcon id='nav_icons' className={pathName == '/contactme' ? "active" : "passive"} />
                        <p id='nav_captions'>Contact Me</p>
                    </Link>
                </div>
            </div>

        </div >
    )
}

export default HomeNav
